module.exports = __webpack_public_path__ + "img/Kürbisschnitzen2022(2).c4b5c546.jpg";